import { DEFAULT_LOCALE } from '@/i18n/config';
import { getIntlLocale } from '@/i18n/intl-locale';

/**
 * @param intlLocale BCP 47 tag — pass `useIntlLocale()` from a component so the
 * month abbreviation follows the active locale.
 */
export const formatDateToMonthNumber = (dateInput: string | number | Date, intlLocale: string = getIntlLocale(DEFAULT_LOCALE)): string => {
  const date = typeof dateInput === 'string' || typeof dateInput === 'number' ? new Date(dateInput) : dateInput;

  return date.toLocaleDateString(intlLocale, {
    month: 'short',
    day: 'numeric',
  });
};
